import AuthStore from "./AuthStore";
import BusinessUnitStore from "./BusinessUnitStore";
import CompanyMeasureAuditStore from "./CompanyMeasureAuditStore";
import CompanyMeasureStore from "./CompanyMeasureStore";
import CompanyObjectiveStore from "./CompanyObjectiveStore";
import DepartmentStore from "./DepartmentStore";
import FolderFileStore from "./FolderFileStore";
import FolderStore from "./FolderStore";
import IndividualScorecardStore from "./IndividualScorecardStore";
import IndividualScorecardReviewStore from "./IndividualScorecardReviewStore";
import MeasureAuditStore from "./MeasureAuditStore";
import MeasureStore from "./MeasureStore";
import ObjectiveStore from "./ObjectiveStore";
import ReportStore from "./ReportStore";
import ScorecardStore from "./ScorecardStore";
import StrategicThemeStore from "./StrategicThemeStore";
import UploadManagerStore from "./UploadManagerStore";
import UserStore from "./UserStore";
import CompanyScorecardMetadataStore from "./CompanyScorecardMetadataStore";
import CompanyScorecardReviewStore from "./CompanyScorecardReviewStore";
import { MainApp } from "../models/App";
import DivisionStore from "./DivsionStore";
import PortfolioStore from "./PortfolioStore";
import ProjectManagementStore from "./ProjectManagementStore";
import ProjectRiskStore from "./ProjectRiskStore";
import ProjectTaskStore from "./ProjectTaskStore";
import ProjectStatusStore from "./ProjectStatusStore";
import FeedbackStore from "./FeedbackStore";
import ProjectLogsStore from "./ProjectLogsStore";
import GeneralTaskStore from "./GeneralTaskStore";
import ScorecardArchiveStore from "./ScorecardArchiveStore";
//360
import ValueStore from "./three-sixty-feeedback-stores/ValueStore";
import ChatStore from "./three-sixty-feeedback-stores/Messages/PrivateMessageChatStore";
import CommitteeRatingStore from "./three-sixty-feeedback-stores/CommitteeRatingStore";
import CommitteeStore from "./three-sixty-feeedback-stores/CommitteeStore";
import LeadershipRatingStore from "./three-sixty-feeedback-stores/LeadershipRatingStore";
import LeadershipStore from "./three-sixty-feeedback-stores/LeadershipStore";
import PrivateMessageStore from "./three-sixty-feeedback-stores/Messages/MessagesStore";
import ProjectRatingStore from "./three-sixty-feeedback-stores/ProjectRatingStore";
import ProjectStore from "./three-sixty-feeedback-stores/ProjectsStore";
import RatingAssignmentStore from "./three-sixty-feeedback-stores/RatingAssignmentStore";
import RatingSessionStore from "./three-sixty-feeedback-stores/RatingSessionStore";
import ServiceRatingStore from "./three-sixty-feeedback-stores/ServiceRatingStore";
import ServiceStore from "./three-sixty-feeedback-stores/ServiceStore";
import TemplateRatingStore from "./three-sixty-feeedback-stores/TemplateRatingStore";
import TemplateStore from "./three-sixty-feeedback-stores/TemplateStore";
import ValueRatingStore from "./three-sixty-feeedback-stores/ValueRatingStore";
import DepartmentObjectiveStore from "./DepartmentObjectiveStore";
import DepartmentMeasureStore from "./DepartmentMeasureStore";
import DepartmentMeasureAuditStore from "./DepartmentMeasureAuditStore";
import DepartmentScorecardMetadataStore from "./DepartmentScorecardMetadataStore";
import DepartmentScorecardReviewStore from "./DepartmentScorecardReviewStore";
import VissionMissionStore from "./VisionMissionStore";
export default class AppStore {
  app: MainApp;

  auth = new AuthStore(this);
  user = new UserStore(this);

  scorecard = new ScorecardStore(this);
  individualScorecard = new IndividualScorecardStore(this);
  individualScorecardReview = new IndividualScorecardReviewStore(this);
 individualScorecardMetadata = new IndividualScorecardStore(this);
  objective = new ObjectiveStore(this);
  measure = new MeasureStore(this);
  measureAudit = new MeasureAuditStore(this);
  strategicTheme = new StrategicThemeStore(this);

  companyObjective = new CompanyObjectiveStore(this);
  companyMeasure = new CompanyMeasureStore(this);
  companyMeasureAudit = new CompanyMeasureAuditStore(this);
  companyScorecardMetadata = new CompanyScorecardMetadataStore(this);
  companyScorecardReview = new CompanyScorecardReviewStore(this);
//departement
  departmentObjective = new DepartmentObjectiveStore(this);
  departmentMeasure = new DepartmentMeasureStore(this);
  departmentMeasureAudit = new DepartmentMeasureAuditStore(this);
  departmentScorecardMetadata = new DepartmentScorecardMetadataStore(this);
  departmentScorecardReview = new DepartmentScorecardReviewStore(this);

    visionmission = new VissionMissionStore(this);
  // scorecard arechive impletmentation
  scorecardArchiveStore = new ScorecardArchiveStore(this);

  division = new DivisionStore(this);
  department = new DepartmentStore(this);
  businessUnit = new BusinessUnitStore(this);
  report = new ReportStore(this);
  folder = new FolderStore(this);
  folderFile = new FolderFileStore(this);

  // upload manager
  uploadManager = new UploadManagerStore(this);

  // project Management Stores
  portfolio = new PortfolioStore(this);
  projectManagement = new ProjectManagementStore(this);
  projectTask = new ProjectTaskStore(this);
  projectRisk = new ProjectRiskStore(this);
  projectStatus = new ProjectStatusStore();
  projectLogs = new ProjectLogsStore(this);

  generalTask = new GeneralTaskStore(this);

  // feedback Store
  feedback = new FeedbackStore(this);

  //360
  value = new ValueStore(this);
  leadership = new LeadershipStore(this);
  messages = new PrivateMessageStore(this);
  ratingAssignments = new RatingAssignmentStore(this);
  valueRating = new ValueRatingStore(this);
  leadershipRating = new LeadershipRatingStore(this);
  chat = new ChatStore(this);
  projects = new ProjectStore(this);
  services = new ServiceStore(this);
  committees = new CommitteeStore(this);
  projectRating = new ProjectRatingStore(this);
  serviceRating = new ServiceRatingStore(this);
  committeeRating = new CommitteeRatingStore(this);
  ratingSession = new RatingSessionStore(this);
  templates = new TemplateStore(this);
  templateRating = new TemplateRatingStore(this);

  constructor(app: MainApp) {
    this.app = app;
  }
}
